<template>
  <div>
    <div class="text-center" v-if="loading">
      <b-spinner class="ms-2" variant="primary"></b-spinner>
    </div>
    <div class="filtro-component" v-if="!loading">
      <PageHeader title="Lote Importações" />
      <div class="row d-flex mb-1">
        <div class="col-md-4">
          <b-form-group label="Status">
            <multiselect v-model="selecaoStatusProjeto" :options="selecaoStatusProjetoLkp" label="name" track-by="name" placeholder="Selecione" select-label="" :max-height="150"/>
          </b-form-group>
        </div>
        <div class="col-md-4">
          <b-form-group class="mb-3" label="Cooperado">
            <multiselect
              v-model="selecaoClienteRural"
              :options="clienteRuralLkp"
              placeholder="Selecione o Cooperado"
              label="name"
              track-by="name"
            />
          </b-form-group>
        </div>
        <div class="col-md-4">
          <b-form-group class="mb-3" label="CPF / CNPJ">
            <b-form-input
              v-mask="
                cpfCnpj.length <= 14 ? '###.###.###-##' : '##.###.###/####-##'
              "
              placeholder="Digite CPF ou CNPJ"
              v-model="cpfCnpj"
              type="text"
            />
          </b-form-group>
        </div>
      </div>

      <div class="row">
        <div class="col-md-12 col-sm-12 d-flex flex-column flex-md-row justify-content-md-end order-1 order-md-2 mb-2 mb-md-0">
          <b-button variant="secondary" class="me-md-3 mb-2 mb-md-0" @click="limpar">
            <i class="mdi mdi-broom"></i> Limpar
          </b-button>
          <b-button variant="primary" @click="emitirFiltro" :disabled="disabledFiltro">
            <i class="mdi mdi-filter-outline"></i> Filtrar
            <b-spinner
              variant="secondary"
              small
              class="ms-2"
              v-if="disabledFiltro"
            ></b-spinner>
          </b-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Multiselect from "vue-multiselect";
import PageHeader from "@/components/page-header";
import clienteRuralMixin from "@/tools/mixins/clienteRuralMixin.js";

export default {
  mixins: [clienteRuralMixin],
  components: { Multiselect, PageHeader },
  data() {
    return {
      loading: true,
      numeroProjeto: "",
      cpfCnpj: "",
      selecaoClienteRural: null,
      selecaoMunicipio: null,
      selecaoProjeto: null,
      selecaoSafra: null,
      selecaoInstituicaoFinanceira: null,
      selecaoLinhaCredito: null,
      selecaoTipoProjeto: null,
      selecaoItemAgropecuario: null,
      selecaoModalidadeSeguro: null,
      selecaoStatusProjeto: null,
      selecaoCooperado: null,
      clienteRuralLkp: [],
      instituicaoFinanceiraLkp: [],
      linhaCreditoLkp: [],
      tipoProjetoLkp: [],
      selecaoSafraLkp: [],
      selecaoMunicipioLkp: [],
      selecaoProjetoLkp: [],
      itemAgropecuarioLkp: [],
      selecaoStatusProjetoLkp: [],
      selecaoModalidadeSeguroLkp: [],
      cooperadoLkp: [],
      loadingInstFinanceira: false,
      cdPessoa: "",
      disabledFiltro: false,
      loadingItemAgropecuario: false,
    };
  },
  async mounted() {
    await this.buscarDados();
    if(this.$store.state.filtroProjetoAstec){
      console.log(this.$store.state.filtroProjetoAstec, "FILTROS PROJETOS")
        await this.verificarFiltro(this.$store.state.filtroProjetoAstec)
      }
  },
  methods: {
    async buscarDados() {
      await this.getNomeRazaoUsuario();
      // await this.buscarClientesRuraisLkp();
      await this.buscarMunicipioUf();
      await this.buscarLkpProjeto();
      await this.buscarLkpSafra();
      await this.buscarLkpLinhaCredito();
      await this.buscarLkpTipoProjeto();
      await this.buscarLkpModalidadeSeguro();
      await this.buscarLkpStatusProjeto(); 
      await this.buscarLkpCooperado();
      await this.verificarCooperado();
      this.loading = false;
    },
    async verificarFiltro(filtro) {
      this.selecaoCooperado = this.clienteRuralLkp.find(
        (el) => el.value == filtro.cdCooperado
      )
      this.selecaoClienteRural = this.clienteRuralLkp.find(
        (el) => el.value == filtro.sqCliente
      );
      this.selecaoLinhaCredito = this.linhaCreditoLkp.find(
        (el) => el.value == filtro.cdLinhaCredito
      );
      this.selecaoTipoProjeto = this.tipoProjetoLkp.find(
        (el) => el.value == filtro.sqTpProjeto
      );
      this.selecaoSafra = this.selecaoSafraLkp.find(
        (el) => `'${el.name}'` == filtro.cdSafra
      );
      this.selecaoItemAgropecuario = this.itemAgropecuarioLkp.find(
        (el) => el.value == filtro.cdItemAgropecuario
      );
      this.selecaoModalidadeSeguro = this.selecaoModalidadeSeguroLkp.find(
        (el) => el.value == filtro.sqModalidadeSeguro
      );
      this.selecaoStatusProjeto = this.selecaoStatusProjetoLkp.find(
        (el) => `'${el.value}'` == filtro.stProjeto
      );
      this.selecaoCooperado = this.cooperadoLkp.find(
        (el) => el.value == filtro.cdCooperado
      );
      this.numeroProjeto = filtro.nrProjeto || "";
      this.selecaoProjeto = this.selecaoProjetoLkp.find(
        (el) => el.value == filtro.cdProjeto
      );
      this.selecaoMunicipio = this.selecaoMunicipioLkp.find(
        (el) => el.value == filtro.sqRegiao
      );

      // Verifica carregamento de dados adicionais
      if (this.selecaoCooperado) {
        await this.carregarInstFinanceira();
        this.selecaoInstituicaoFinanceira = this.instituicaoFinanceiraLkp.find(
          (el) => el.value == filtro.cdInstituicaoFinanceira
        );
      }
      if (this.selecaoTipoProjeto && this.selecaoSafra) {
        await this.carregarItemAgropecuario();
        this.selecaoItemAgropecuario = this.itemAgropecuarioLkp.find(
          (el) => el.value == filtro.cdItemAgropecuario
        );
      }
      this.emitirFiltro();
    },

    async verificarCooperado() {
      if (this.cooperadoLkp.length > 0) {
        const cooperadoEncontrado = this.cooperadoLkp.find(cooperado => cooperado.value === this.cdPessoa);
        if (cooperadoEncontrado) {
          this.selecaoCooperado = cooperadoEncontrado;
          this.carregarInstFinanceira();
        } else {
          this.selecaoCooperado = null;
        }
      } else {
        this.selecaoCooperado = null;
      }
      return;
    },

    async getNomeRazaoUsuario() {
      try {
        const token = this.$store.state.access_token;
        const isErp = this.$store.state.user?.tipoUsuario === 'erp' || this.$store.state.me?.user_erp;
        const endpointMe = isErp ? "api/authErp/meErp" : "api/auth/me";
        const headerMe = { headers: { Authorization: `Bearer ${token}` } };
        const response = await this.$http.get(endpointMe, headerMe);
        this.cdPessoa = response.data.cd_pessoa;
      } catch (err) {
        console.log(err);
        this.logoutUser();
      }
    },

    limpar() {
      this.selecaoClienteRural = null;
      this.selecaoMunicipio = null;
      this.selecaoProjeto = null;
      this.selecaoSafra = null;
      this.selecaoInstituicaoFinanceira = null;
      this.selecaoLinhaCredito = null;
      this.selecaoTipoProjeto = null;
      this.selecaoItemAgropecuario = null;
      this.numeroProjeto = "";
      this.selecaoModalidadeSeguro = null;
      this.selecaoStatusProjeto = null;
      this.$store.commit("PARAMETROS_FILTRO_PROJETO_ASTEC", null);
    },

    async emitirFiltro() {
      console.log("TESTE 1")
      this.disabledFiltro = true;
      const filtro = "1";
      // this.$store.commit("PARAMETROS_FILTRO_PROJETO_ASTEC", filtro);
      this.$emit('loteImportacaoAstecFiltrados', filtro, () => {
        this.disabledFiltro = false;
      });
    },

    async importarCSV() {
      this.$refs.loteImportacaoModal.abrirModal();
    },

    async carregarInstFinanceira(){
      this.instituicaoFinanceiraLkp = [];
      this.selecaoInstituicaoFinanceira = null;
      this. loadingInstFinanceira = true;
      await this.buscarLkpInstituicaoFinanc(this.selecaoCooperado.value);
      this. loadingInstFinanceira = false;
    },
    montarObjetoFiltro() {
      const dados = {
        sqCliente: this.selecaoClienteRural ? this.selecaoClienteRural.value : null,
        sqRegiao: this.selecaoMunicipio ? this.selecaoMunicipio.value : null,
        cdProjeto: this.selecaoProjeto ? this.selecaoProjeto.value : null,
        cdSafra: this.selecaoSafra ? `'${this.selecaoSafra.name}'` : null,
        cdInstituicaoFinanceira: this.selecaoInstituicaoFinanceira ? this.selecaoInstituicaoFinanceira.value : null,
        cdLinhaCredito: this.selecaoLinhaCredito ? this.selecaoLinhaCredito.value : null,
        sqTpProjeto: this.selecaoTipoProjeto ? this.selecaoTipoProjeto.value : null,
        cdItemAgropecuario: this.selecaoItemAgropecuario ? this.selecaoItemAgropecuario.value : null,
        sqModalidadeSeguro: this.selecaoModalidadeSeguro ? this.selecaoModalidadeSeguro.value : null,
        stProjeto: this.selecaoStatusProjeto ? `'${this.selecaoStatusProjeto.value}'` : null,
        cdCooperado: this.selecaoCooperado ? this.selecaoCooperado.value : null,
        nrProjeto: this.numeroProjeto ? this.numeroProjeto : null,
      };
      return dados;
    },
    desabilitar(){
      return false;
    },
    async carregarItemAgropecuario(){
      if(this.selecaoTipoProjeto && this.selecaoSafra){
        this.selecaoItemAgropecuario = null;
        this.loadingItemAgropecuario = true;
        try {
          const response = await this.$http.get("/api/astec/getLkpItemAgropecuario/" + this.selecaoTipoProjeto.value + "/" + this.selecaoSafra.epoca);
          this.itemAgropecuarioLkp = response.data.map(itemAgropecuario => ({
            name: itemAgropecuario.DISPLAY,
            value: itemAgropecuario.ID,
          }));
        } catch (err) {
          this.$tools.alerta(err.response.data.message, "error");
        }
        this.loadingItemAgropecuario = false;
      } else {
        this.selecaoItemAgropecuario = null;
        this.itemAgropecuarioLkp  = [];
      }
      return;
    },
  }
};
</script>

<style scoped>
/* Estilos específicos do componente */
</style>
